import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=03543f04&lang=pug"
import script from "./LanguageSelector.vue?vue&type=script&lang=ts"
export * from "./LanguageSelector.vue?vue&type=script&lang=ts"
import style0 from "./LanguageSelector.vue?vue&type=style&index=0&id=03543f04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports